export default __webpack_public_path__ + "static/media/1920px-Node.js_logo.svg.1dc6b450.png";